export const siteConfig = {
  name: '磁力网站大全',
  tagline: '最新磁力资源搜索平台',
  description: '磁力网站精选推荐，汇聚全网最新磁力链接资源，支持磁力搜索、磁力下载一键直达。',
  url: 'https://www.ciliwangzhan.com',
  logo: '磁力网站大全',
  foundedYear: 2024,
  stats: {
    totalSites: 1280,
    categories: 8,
    dailyVisits: 50000,
    updatedResources: 30000,
  },
  contact: {
    email: 'contact@ciliwangzhan.com',
    wechat: 'ciliwangzhan',
    qq: '1234567890',
  },
  footerLinks: [
    { label: '首页', href: '/' },
    { label: '影视资源', href: '/category/yingshi' },
    { label: '软件工具', href: '/category/ruanjian' },
    { label: '游戏天地', href: '/category/youxi' },
    { label: '音乐音效', href: '/category/yinyue' },
    { label: '学习教程', href: '/category/xuexi' },
    { label: '关于我们', href: '/about' },
  ],
};

export const aboutContent = {
  brandIntro: '磁力网站大全成立于2024年，是国内专业的磁力资源导航平台。我们致力于为用户提供最新、最全、最稳定的磁力网站导航服务，帮助用户快速找到优质的磁力资源。团队由资深互联网从业者和磁力资源爱好者组成，凭借对行业的深刻理解和对用户体验的极致追求，磁力网站大全已成为国内磁力导航领域的标杆平台。',
  mission: '打破信息壁垒，让每一位用户都能轻松找到需要的磁力资源。我们相信，好的资源应该被更多人发现和使用。磁力网站大全将持续优化导航体验，拓展资源覆盖范围，成为用户寻找磁力资源的首选入口。',
  values: [
    { title: '全面收录', description: '持续发现和收录优质磁力网站，覆盖影视、软件、游戏、音乐、学习等全品类资源。' },
    { title: '客观评价', description: '基于多维度指标对收录网站进行客观评分，帮助用户做出明智选择。' },
    { title: '及时更新', description: '每周巡检已收录网站，确保链接有效，信息准确，让用户告别失效链接。' },
    { title: '用户至上', description: '持续优化产品体验，倾听用户反馈，打造最好用的磁力网站导航平台。' },
  ],
  testimonials: [
    { name: '张先生', role: '影视爱好者', content: '磁力网站大全帮我找到了好几个超好用的磁力搜索站，资源更新快，搜索也很准，已经推荐给身边的朋友了！' },
    { name: '李同学', role: '大学生', content: '作为一个经常需要下载学习资料的学生，磁力网站大全的学习资源分类太实用了，省去了很多找资源的时间。' },
    { name: '王工', role: '软件工程师', content: '软件工具板块收录的磁力站质量很高，找开发工具和开源软件都很方便，分类清晰，体验很好。' },
    { name: '赵女士', role: '自由职业者', content: '通过磁力网站大全发现了不少优质的纪录片资源站，画质高清资源丰富，每周都会来看看有没有新收录的网站。' },
  ],
};